/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_5Inputs */



/**
* | output |
* | --- |
* | "Team Projects & Sharing" |
*
* @param {Signup_Feature_Pro_5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_5 = /** @type {((inputs?: Signup_Feature_Pro_5Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_5Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	if (locale === "de") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	if (locale === "it") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	if (locale === "es") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Team Projects & Sharing")
	return /** @type {LocalizedString} */ ("Team Projects & Sharing")
});